const AUTOMATIC_RESET_DELAY_MS = 30000;

let transitionDepth = 0;
let automaticResetTimeoutId = null;

export function beginAuthenticationTransition() {
    transitionDepth++;
    scheduleAutomaticReset();
}

export function endAuthenticationTransition() {
    transitionDepth = Math.max(0, transitionDepth - 1);

    if (transitionDepth === 0) {
        clearAutomaticReset();
    }
}

export function isAuthenticationTransitioning() {
    return transitionDepth > 0;
}

function scheduleAutomaticReset() {
    clearAutomaticReset();
    automaticResetTimeoutId = globalThis.setTimeout(resetAuthenticationTransition, AUTOMATIC_RESET_DELAY_MS);
}

function clearAutomaticReset() {
    if (automaticResetTimeoutId !== null) {
        globalThis.clearTimeout(automaticResetTimeoutId);
        automaticResetTimeoutId = null;
    }
}

function resetAuthenticationTransition() {
    transitionDepth = 0;
    automaticResetTimeoutId = null;
}
